module.exports = __webpack_public_path__ + "static/media/Laidley Street, San Francisco, CA6.88ec0c9a.jpg";